module.exports = __webpack_public_path__ + "img/ill_spot_search_2.b2129ace.svg";